import { MoreVert } from '@mui/icons-material';
import { IconButton, Menu, MenuItem } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import DialogAccepterIntteruptionOrAnnulerMission from '../../../Components/Dialogs/DialogAccepterIntteruptionOrAnnulerMission';

// import RenouvelerBDCBtn from './RenouvelerBDCBtn';
export const MenuButtonOptionsRenouvelerModifier = ({ bdc, getMissions }) => {
    MenuButtonOptionsRenouvelerModifier.propTypes = {
        bdc: PropTypes.any,
        getMissions: PropTypes.func,
        // mission: PropTypes.any,
        // index: PropTypes.any,
    };
    // console.log(bdc);
    // const scroll='paper';
    const [anchorEl, setAnchorEl] = useState(null);
    const [openDialogAnnulerMission, setOpenDialogAnnulerMission] = useState(false);
    const navigate = useNavigate();
    const { i18n } = useTranslation();
    return (
        <React.Fragment key={bdc?.bdcId}>
            {
                //on peut pas actionner sur une mission qui n est pas  'encours' / 'aValider'(modifier/anuller/update)
                (bdc?.statutMission =='encours' || bdc?.statutMission =='aVenir') &&
                // if we are in the latest bdc=> display the btn <==> index == mission?.bdc.length - 1 && index == mission?.BDCs.length - 1 &&  <RenouvelerBDCBtn // variant='error' lastBDC={bdc} missionId={mission?._id} /> */}
                bdc?.isLastBDC &&
                <div>
                    <IconButton
                        size="large"
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        onClick={(event)=>{
                            setAnchorEl(event.currentTarget);
                        }}
                        color="inherit"
                    >
                        <MoreVert />
                    </IconButton>

                    <Menu
                        id="menu-appbar"
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        open={Boolean(anchorEl)}
                        onClose={()=>{
                            setAnchorEl(null);
                        }}
                    >
                        <MenuItem
                            onClick={() => {
                                //! bdc?.id is a mission._id, not a bdc one :)
                                navigate('/admin/modify/' + bdc?.id);
                            }}
                        >{i18n.t('Modifier')}</MenuItem>
                        {bdc?.statutMission =='encours' &&
                        <MenuItem
                            onClick={() => {
                                // we pass missionId to url, to create a new bdc for this mission
                                navigate('/admin/renewBDC/' + bdc?.id);
                            }}
                        >
                            {i18n.t('Renouveler')}
                        </MenuItem>}
                        <MenuItem
                            onClick={() => {
                                setOpenDialogAnnulerMission(true);
                            }}
                        >
                            {i18n.t('Annuler')}
                        </MenuItem>
                    </Menu>
                </div>
            }

            {/* Dialog pour annuler une mission */}
            <DialogAccepterIntteruptionOrAnnulerMission
                missionId={bdc?.id}
                openDialogAccept={openDialogAnnulerMission}
                handleCloseDialogAccept={() => {
                    setOpenDialogAnnulerMission(false);
                    getMissions();
                }}
                mode={'annuler'}
            />
        </React.Fragment>);
};

// ? before Menu/menuItem [I used dialog]
{/* <IconButton
                // key={bdc?.bdcId}
                aria-label="openChoices"
                onClick={() => {
                    console.log('hi');
                    console.log(bdc);
                    console.log(bdc?.bdcId);
                    // handleClickOpenChoices();
                    // setOpenChoices(true);
                }}
            >
                <MoreVert  />
            </IconButton> */}
{/* <Dialog
                // fullScreen
                // TransitionComponent={Transition}
                // scroll={scroll}
                // aria-labelledby="scroll-dialog-title"
                // fullWidth
                // aria-describedby="scroll-dialog-description"
                onClose={handleCloseChoices}
                open={openChoices}
                maxWidth='lg'
            >
                <DialogContent> <p> helllo {JSON.stringify(bdc)} </p> </DialogContent>*/}
{/* <DialogContent>
                <p>
    choisir votre action sur ce bdc {mission?.missionId}
                </p>
            </DialogContent> */}
{/*  <DialogActions>
                     <Button onClick={handleCloseChoices}>Cancel</Button>
                    <Button>modifier</Button>
                    //! was Generate CRA manually, I automated it, so I deactivate it
                    */}
{/* // On est sur une mission encours
                    mission?.statutMission =='encours' &&
                    // on pointe sur le dernier BDC
                    index == mission?.BDCs.length - 1 &&
                    //si mois actuelle >= mois debut BDC ? voir comment faire pr le mois 12 => calculer durerr sans ABS()
                    //dans un intervale de temps dedant le deroulement du BDC
                    moment().month()+1 >= moment(bdc?.dateDebutBDC).month()+1 &&
                    moment().month()+1 <= moment(bdc?.dateFinBDC).month()+1 &&
                    // ! NO need for this calculation, just a monthly job will do the stuff now calculateDurationBetweenDates(moment(bdc?.dateDebutBDC), moment()) < DURREE_START_BDC__GENERATION_CRA &&
                    //CRAs will be generated in the end of the month [last date, at 23:00]
                    <GenerateCRABtn
                        // variant='error'
                        lastBDC={bdc}
                        missionId={mission?._id}
                    /> */}
{/*
                </DialogActions>
            </Dialog>*/}
//! was Generate CRA manually, I automated it, so I deactivate it
// const GenerateCRABtn = ({variant,lastBDC, missionId}) => {
//     GenerateCRABtn.propTypes ={
//         variant: PropTypes.string,
//         lastBDC: PropTypes.any,
//         missionId: PropTypes.string.isRequired,
//     };
//     const axiosPrivate = useAxiosPrivate();
//     const GenerateCRA = async (e) => {
//         e.preventDefault();
//         console.log(missionId);
//         try {
//             const response = await axiosPrivate.post(
//                 'cra/addCra',
//                 {
//                     missionId,
//                     bdcId:lastBDC?._id,
//                     'year': 2022,
//                     'nbrDays': 19,
//                     'FactureM': 500,
//                     'Regularisation': 10,
//                     'Gratuite': 0,
//                     'montantTotal': 0,
//                     'month': 10
//                 },
//                 {
//                     headers: {
//                         'Content-Type': 'application/json',
//                     },
//                     withCredentials: true,
//                 }
//             );
//             const responseData1 = await response.data;
//             console.log('second Step Response', responseData1);
//             Swal.fire({
//                 icon: 'success',
//                 title: 'Created',
//                 text: responseData1.message
//             });
//         } catch (error) {
//             console.log(error, error?.response);
//             Swal.fire({
//                 icon: 'error',
//                 title: 'Oops...',
//                 text: 'erreur de generation CRA !\n' + error?.response?.data?.error,
//             });
//         }
//     };

//     return <>
//         <Button
//             variant='contained'
//             color={variant}
//             onClick={GenerateCRA}
//         >Generate CRA</Button>
//     </>;
// };
// export default  GenerateCRABtn;
